module.exports = __webpack_public_path__ + "img/big.14eab082.jpg";